export const SET_APPVERSION = 'SET_APPVERSION';

export default {
    setNetworkOnline: (state, value) => (state.networkOnLine = value),
    setSWRegistrationForNewContent: (state, value) =>
        (state.SWRegistrationForNewContent = value),
    setShowAddToHomeScreenModalForApple: (state, value) =>
        (state.showAddToHomeScreenModalForApple = value),
    setRefreshingApp: (state, value) => (state.refreshingApp = value),
    [SET_APPVERSION]: (state, value) => (state.appVersion = value),
};